import { observable, action, computed } from "mobx";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { RateLibrary } from "modules/rateLibrary/models/Index";
import { RateLibraryService } from "modules/rateLibrary/RateLibraryService";
import * as libLocations from "modules/rateLibrary/assets/rateLibraryLocation";
import * as _ from "lodash";
import { RateLibraryUserImage } from "./models/RateLibraryUserImage";
import { LoginService } from "modules/login/LoginService";
import { User } from "modules/login/models/User";
import { default as firebase } from "common/Firebase";

class Store {
  buttonFileUpload: any = null;
  search: string = "";
  stateSearch: string = "BR";
  snapshotEventFired: boolean = false;
  snapshotRateLibrariesFired: boolean = false;
  @observable currentTab: Number = 0;
  @observable myLibraries: FirebaseDocument<RateLibrary>[];
  @observable publicLibraries: FirebaseDocument<RateLibrary>[];

  @observable librariesSearch: FirebaseDocument<RateLibrary>[] = [];
  @observable publicLibrariesSearch: FirebaseDocument<RateLibrary>[] = [];
  @observable publicRateLibraries: FirebaseDocument<RateLibrary>[] = [];
  updateImageRateLibrary: any = false;
  @observable deleteRateLibrary: any = false;
  @observable updateRateLibraryStatus: any = false;
  @observable openModelRateLibrary = false;
  @observable rateLibraryLocationRef: FirebaseDocument<RateLibrary>;
  @observable openUpdateLocationDialog = false;
  @observable openShareLibraryDialog = false;
  @observable openShareLibrary: any = false;
  @observable editLocation: any = [];
  @observable editModeRateLibrary = false;
  @observable layerAdd: boolean = false;
  @observable rateLibrarySelected: FirebaseDocument<RateLibrary>;
  @observable librariesView: FirebaseDocument<RateLibrary>[] = [];
  @observable progressStatusUpload: {} = {};
  @observable progressStatusUploadFile: {} = {};
  @observable snackOpen: boolean = false;
  @observable snackMessage: string = "";
  @observable loading: boolean = false;

  resetStore() {
    this.buttonFileUpload = null;
    this.search = "";
    this.snapshotEventFired = false;
    this.currentTab = 0;
    this.librariesSearch = [];
    this.publicLibrariesSearch = [];
    this.publicRateLibraries = [];
    this.updateImageRateLibrary = false;
    this.openModelRateLibrary = false;
    this.openUpdateLocationDialog = false;
    this.openShareLibraryDialog = false;
    this.editModeRateLibrary = false;
    this.layerAdd = false;
    this.librariesView = [];
    this.progressStatusUpload = {};
    this.progressStatusUploadFile = {};
    this.snackOpen = false;
    this.snackMessage = "";
    this.snapshotRateLibrariesFired = false;
  }

  @action
  async setRateLibrarySelected(id): Promise<void> {
    await RateLibraryService.setRateLibrarySelected(id);
  }

  @action
  loadRateLibraries(): void {
    RateLibraryService.fetchAvailableRateLibraries();
  }

  @action
  getLocationLabel(value): string {
    let location = _.find(libLocations.availableLocations, function (o) {
      return o.value == value;
    });
    let state = location != undefined ? location.label : "";
    return state;
  }

  async saveUsers(users) {
    RateLibraryService.updateSharedDatabase(users);
  }
}

let RateLibraryStore = new Store();

export { RateLibraryStore };



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/RateLibraryStore.ts